import React, { useRef, useState, useContext } from "react";
import { IoMdArrowUp } from "react-icons/io";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { apiFetch } from "../../../services/fetchApi";
import { DContext } from "../../../../context/Datacontext";


export const ResumeParsing = ({ candidate, setCandidate, setIsResumeParsing }) => {
    const { BeURL, showAlert, showConfirm } = useContext(DContext);

    const fileInputRef = useRef(null);

    const [fileName, setFileName] = useState("");
    const [parsedText, setParsedText] = useState("");
    const [loading, setLoading] = useState(false);

    const handleClick = () => {
        if (loading) return;

        fileInputRef.current?.click();
    };

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];

        if (!file) return;

        const allowedTypes = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ];

        if (!allowedTypes.includes(file.type)) {
            showAlert("Only PDF, and DOCX files are allowed.");
            e.target.value = "";
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            showAlert("File size exceeds 5MB.");
            e.target.value = "";
            return;
        }

        setFileName(file.name);
        setParsedText("");

        const confirmed = await showConfirm(`Are you sure you want to parse ? If you selected the wrong resume, you can cancel and choose another file.`, file?.name);

        if (!confirmed)
            return

        const formData = new FormData();
        formData.append("resume", file);

        try {
            setLoading(true);

            const res = await apiFetch(`${BeURL}/create-parsing-candidate`, {
                method: "POST",
                body: formData
            });
            const data = await res.json();

            if (!res.ok || !data.success) {
                showAlert(data.message || "Resume parsing failed.");
                return;
            }

            if (data.candidate) {
                setCandidate(data.candidate);
                setIsResumeParsing(true)
            }

            showAlert(data.message);

        } catch (error) {
            console.log("Resume Parsing Error:", error);
            showAlert("Unable to Parse the Resume");

        } finally {
            setLoading(false);

            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    };



    return (
        <div className="w-full grid gap-5 mb-5">

            <p>
                Resume{" "} <span className="text-red-500">*  </span>
            </p>

            <div className="w-full bg-white border rounded-xl p-6 flex flex-col justify-center items-center text-center">

                <h3 className="text-lg font-semibold">
                    Upload Your Resume{" "} <span className="text-red-500"> *</span>
                </h3>

                <p className="text-gray-600 mb-4">
                    Upload your resume to automatically create your candidate profile.
                </p>

                <div
                    disabled={loading || candidate?.emailAddress}
                    onClick={handleClick}
                    className={` border-2 border-dashed border-blue-500 p-6 rounded-md flex flex-col items-center w-full max-w-md hover:bg-blue-50 ${loading || candidate?.emailAddress
                        ? "opacity-50 cursor-not-allowed pointer-events-none" : "cursor-pointer"}`}
                >

                    <IoMdArrowUp className="h-10 w-10 text-blue-600 mb-2" />

                    <p className="text-blue-600 underline">
                        {fileName
                            ? fileName
                            : "Click here to upload resume"}
                    </p>

                </div>

                <input
                    type="file"
                    ref={fileInputRef}
                    className="hidden"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"
                />

                {loading && (
                    <div className="flex items-center mt-4 space-x-2">

                        <AiOutlineLoading3Quarters className="animate-spin text-blue-600 text-2xl" />

                        <p className="text-blue-600 font-semibold">
                            Parsing resume...
                        </p>

                    </div>
                )}

                {fileName && !loading && (
                    <div className="mt-4">

                        <p className="text-sm text-gray-700">
                            Selected file:
                        </p>

                        <p className="text-sm font-medium text-blue-600">
                            {fileName}
                        </p>

                    </div>
                )}

                {candidate?.emailAddress && !loading && (
                    <div className="mt-4 p-4 border rounded-lg bg-green-50 w-full text-left">



                        {candidate.applicantFullName && (
                            <p className="text-sm mt-1">

                                {candidate.applicantFullName}'s <span className="font-semibold text-green-700">
                                    resume parsed successfully
                                </span>
                            </p>
                        )}


                    </div>
                )}

                {/* {parsedText && (
                    <div className="mt-4 p-4 border rounded bg-gray-100 w-full text-left">

                        <h4 className="font-semibold">
                            Parsed Resume Text:
                        </h4>

                        <p className="text-sm whitespace-pre-wrap">
                            {parsedText}
                        </p>

                    </div>
                )} */}

                <p className="text-sm text-gray-500 mt-4">
                    Supported formats: PDF, DOCX | Max size: 5MB
                </p>

            </div>

        </div>
    );
};